import { Breed } from "../common/types/breed";
import { getRequest } from "./request";

export const getBreeds = async (): Promise<Breed[]> => {
  return await getRequest<Breed[]>(`breeds`).then((res) => res.data);
};
